import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value = 5, size = 14, className = "" }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full;
        const isHalf = i === full && half;
        return (
          <span key={i} className="relative inline-flex">
            <Star size={size} className="text-gray-300" fill="currentColor" />
            {(filled || isHalf) && (
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: isHalf ? "50%" : "100%" }}
              >
                <Star size={size} className="text-brand" fill="currentColor" />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
